import { useQuery } from '@apollo/client';
import { gqlTypes } from '../types';
import { purchaseSubscriptionDeviceQuery } from '../graphql-operations';
import { fiCurrencyToGQL, useLocale } from '../contexts/LocaleContext';

interface UpgradeTargetDevice {
  petName?: string;
  subscriptionEndsAt?: string;
}

/**
 * Looks up the existing-dog upgrade target's pet name and subscription end date for a given
 * `moduleId`. Returns empty values while the query is in flight. Reuses
 * `purchaseSubscriptionDeviceQuery` so Apollo's cache is shared with other upgrade flows that
 * have already fetched the same device.
 */
export default function useUpgradeTargetDevice(moduleId: string): UpgradeTargetDevice {
  const { currency, country } = useLocale();
  const { data } = useQuery<
    gqlTypes.ECOMMERCE_purchaseSubscriptionDevice,
    gqlTypes.ECOMMERCE_purchaseSubscriptionDeviceVariables
  >(purchaseSubscriptionDeviceQuery, {
    skip: !moduleId,
    variables: {
      moduleId,
      inAppFlow: true,
      monthlyUpgrade: false,
      currency: fiCurrencyToGQL(currency),
      countryCode: country.toString(),
    },
  });

  return {
    petName: data?.device?.pet?.name ?? undefined,
    subscriptionEndsAt: data?.device?.subscription?.currentTermEndsAt ?? undefined,
  };
}
